<template>
  <cTable :fields="fields" :footer="footer" :config="config" ref="table">
  </cTable>
</template>
<script>
import numFun from "@/utils/numFun";
import cTable from "@/base/common/index";

export default {
  props: {
    row: Array,
  },
  components: {
    cTable, 
  },
  mounted() {
    this.$refs.table.list = this.row;
  },
  data() {
    return {
      config: {
        resize: false,
        slot: "div",
        height: "auto",
        showFooter: true,
        footerCellClassName: "col-red",
      },
      footer: {
        show: () => false,
      },
      fields: [
				{
				  name: () => this.$t("currency_t"),
				  key: "check_amount_currency",
				  minWidth: 130,
				},
				{
				  name: () => this.$t("reChAmount"),
				  key: "total_amount",
				  minWidth: 130,
				},
				{
				  name: () => this.$t("check_amount"),
				  key: "check_amount",
				  minWidth: 130,
				},
				{
				  name: () => this.$t("check_time"),
				  key: "pay_time",
				  minWidth: 159,
					methods:{
						render({value}){
							return this.format.timeFormat(value * 1000)
						}
					}
				},
				{
				  name: () => this.$t("arrears"),
				  key: "arrears_amount",
				  minWidth: 130,
				},
      ],
    };
  },
};
</script>
